import Image from "next/image";
// CMS-supplied hrefs are emitted verbatim - do NOT swap this for @repo/ui/navigation.
// The CMS localizes its own URLs (e.g. "cl/es/centro-de-ayuda/") and also returns
// external/relative ones, so prefixing here would double or corrupt the locale.
import Link from "next/link";

import southAmericaMap from "@repo/ui/assets/maps/south-america.png";
import type { Destination } from "@repo/ui/types/cms/common";

interface InternationalDestinationsProps {
  destination: Destination;
}

export function InternationalDestinations({
  destination,
}: Readonly<InternationalDestinationsProps>) {
  const { title, country_group, image } = destination;

  return (
    <>
      <div className="text-center md:mr-8" data-testid="international-destinations-header-section">
        {title && (
          <h3
            className="mb-3 hidden text-xl font-semibold md:block"
            data-testid="international-destinations-title-lbl"
          >
            {title}
          </h3>
        )}

        {image && (
          <Image
            src={southAmericaMap}
            alt="Mapa de Sudamérica"
            width={160}
            height={220}
            className="h-auto w-30 md:h-[220px] md:w-[160px]"
            data-testid="international-destinations-image"
          />
        )}
      </div>
      <div
        className="mt-8 hidden columns-3 gap-x-16 md:block"
        data-testid="international-destinations-countries-section"
      >
        {country_group?.map((group) => (
          <ul key={group.country_name} data-testid="international-destinations-country-group-list">
            <li
              key={group.country_name}
              className="list-disc font-semibold"
              data-testid="international-destinations-country-name-lbl"
            >
              {group.country_name}
              <ul
                className="mb-4 text-sm font-light"
                data-testid="international-destinations-city-list"
              >
                {group.citites.map((city) => (
                  <li key={city.text} data-testid="international-destinations-city-item">
                    <Link href={city.url} data-testid="international-destinations-city-link">
                      {city.text}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        ))}
      </div>
    </>
  );
}
